import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Header, Table, Container, Loader
} from 'semantic-ui-react'
import TeamActions from 'Redux/TeamRedux'
import styles from './ListStyles'

class TeamsList extends Component {

  componentDidMount () {
    this.props.teamsListRequest()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.teams !== nextProps.teams &&
        nextProps.teams.length === 1) {
      this.props.history.push(`/teams/${nextProps.teams[0].id}/users`)
    }
  }

  openTeam = (teamId) => () => {
    this.props.history.push(`/teams/${teamId}/users`)
  }

  render () {
    return (
      <Container>
        <Loader active={this.props.listFetching} />
        <Table celled fixed singleLine selectable>
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan='4'>
                <Header as='h3'>Teams</Header>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell># Projects</Table.HeaderCell>
              <Table.HeaderCell># Members</Table.HeaderCell>
              <Table.HeaderCell>Role</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.props.teams.map((team, index) => (
              <Table.Row className={styles.teamRow}
                         key={team.id}
                         onClick={this.openTeam(team.id)}>
                <Table.Cell>{team.name}</Table.Cell>
                <Table.Cell>{team.projects.length}</Table.Cell>
                <Table.Cell>
                  {team.admins.length + team.editors.length}
                </Table.Cell>
                <Table.Cell>
                  {
                    team.admins.find(ad => ad.email === this.props.username)
                      ? 'Admin' : 'Editor'
                  }
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  listFetching: state.teams.listFetching,
  username: state.auth.userData.email,
  teams: state.teams.listData
})

const mapDispatchToProps = (dispatch) => ({
  teamsListRequest: (projectId) =>
    dispatch(TeamActions.teamsListRequest(projectId))
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamsList)



// WEBPACK FOOTER //
// ./src/Pages/Teams/List.js